export const LOGO =
  "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";

export const options = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI4Y2ZmMDMwYzk3YjlmZGQ2OTBjYTYzNTRiYWU1MGM4YiIsIm5iZiI6MTcyMDUwODc5MC45OTEyODMsInN1YiI6IjY2OGI2ZThjNTg2YWJmNDRmZDg2MmMzYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.h9TjMONvT5U1GDSrebO30fkxQNlGe3oc0veJMnGO7hc",
  },
};

export const IMG_CDN = "https://image.tmdb.org/t/p/w500";

export const supported_languages = [
  {
    identifier: "en",
    name: "English",
  },
  {
    identifier: "hindi",
    name: "हिंदी",
  },
];

export const GEMINI_API = process.env.REACT_APP_GEMINI_API_KEY;
